import React, { Fragment, useEffect, useState } from "react";
import { Box, Card, Grid2 as Grid, Typography } from "@mui/material";
import { PencilSimpleLine } from "@phosphor-icons/react";
import { GenericAvatar } from "../../components/generic/GenericAvatar";
import useStore from "../../states/store";
import { GenericIconLabel } from "../../components/generic/GenericIconLabel";
import { GenericDialog } from "../../components/generic/GenericDialog";
import { EDIT_PROFILE_LABEL } from "../../enums/generalEnums";
import { UploadImage } from "../../components/ui/profileSetup/bio/UploadImage";
import { BIO_KEY, VERIFY_FACE_ID_KEY } from "../../enums/profileSetupEnums";
import { createOrUpdateUserDetails } from "../../config/apisauce";
import { BasicInformationForm } from "../../components/ui/profileSetup/basicInformation/BasicInformationForm";
import useNotiStack from "../../hooks/useNotiStack";
import DialogLayout from "../../components/layouts/DialogLayout";

export const BasicProfileCard = ({ userDetails, refetchData }) => {
  const { success } = useNotiStack();
  const [{ loggedIndUserDetails }, { setLoggedIndUserDetails }] = useStore();
  const [uploadedImages, setUploadedImages] = useState();
  const [profilePhoto, setProfilePhoto] = useState({});
  const [openBasicProfileDialog, setOpenBasicProfileDialog] = useState(false);

  const handleSubmit = async (values, key) => {
    const params = {
      ...values,
      user_id: userDetails?.user_id,
      current_step: VERIFY_FACE_ID_KEY
    };
    const { ok, data } = await createOrUpdateUserDetails(params);
    if (ok) {
      if (key !== BIO_KEY) {
        success('Profile has been updated!');
        setOpenBasicProfileDialog(false);
        setLoggedIndUserDetails({
          ...loggedIndUserDetails,
          name: data?.name,
          profession: data?.profession,
          gender: data?.gender,
          country: data?.country
        });
      } else {
        setLoggedIndUserDetails({
          ...loggedIndUserDetails,
          profile_picture_location: profilePhoto?.location
        });
      }
      refetchData();
    }
  };

  useEffect(() => {
    setProfilePhoto(userDetails?.profile_picture);
  }, [userDetails?.profile_picture]);

  return (
    <Box>
      <Card sx={{ p: 3 }}>
        <Grid container justifyContent={'space-between'}>
          <Grid container item gap={2} alignItems={'center'}>
            <Grid item>
              <GenericAvatar size={'80px'} location={loggedIndUserDetails?.profile_picture_location} />
            </Grid>
            <Grid item>
              <Typography fontWeight={800} variant="h6" color="primary" textTransform={'capitalize'} width={{ xs: 185, md: '100%' }} noWrap>{loggedIndUserDetails?.name}</Typography>
              <Typography fontWeight={800} color="text.light">{loggedIndUserDetails?.profession}</Typography>
              <Typography color="text.light" mt={1}>{userDetails?.state ? `${userDetails?.state}, ${loggedIndUserDetails?.country}` : loggedIndUserDetails?.country}</Typography>
            </Grid>
          </Grid>
          <Grid item>
            <GenericIconLabel
              onClick={() => setOpenBasicProfileDialog(true)}
              typographyProps={{ fontWeight: 700 }}
              color={'primary.main'}
              label={'Edit'}
              icon={<PencilSimpleLine size={16} weight="bold" />}
              sx={{
                cursor: 'pointer'
              }}
            />
          </Grid>
        </Grid>
      </Card>
      <GenericDialog
        width={'854px'}
        title={EDIT_PROFILE_LABEL}
        openDialog={openBasicProfileDialog}
        handleClose={() => setOpenBasicProfileDialog(false)}
      >
        <DialogLayout height={{ md: '100%' }}>
          <UploadImage
            uploadedImages={uploadedImages}
            profilePhoto={profilePhoto}
            currentPhotoId={userDetails?.profile_picture_id}
            setUploadedImages={setUploadedImages}
            handleSubmit={handleSubmit}
            userId={userDetails?.user_id}
            setProfilePhoto={setProfilePhoto}
          />
          <Box mt={2}>
            <Typography mb={1} variant="subtitle1" fontWeight={700} color="text">Basic Information</Typography>
            <BasicInformationForm
              isProfileSetup={false}
              initialUserDetail={userDetails}
              submitText={'Save Changes'}
              handleSubmit={handleSubmit}
              handleCloseDialog={() => setOpenBasicProfileDialog(false)}
            />
          </Box>
        </DialogLayout>
      </GenericDialog>
    </Box>
  );
}; 